import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({ name: 'spReverseArray' })
export class SpReverseArrayPipe implements PipeTransform {
    transform(value: any[]): any[] {
        if (!Array.isArray(value)) {
            return value;
        }
        return [...value].reverse();
    }
}
